var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopAtomo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278.3,
    height: 232.89,
    viewBox: "0 0 278.3 232.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e32438;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187.11 -238.167)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.61 238.683)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.645)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.57,470.557c-10.962,0-24.763-5.952-40.269-17.561-21.351-15.983-43.952-41-63.64-70.435s-34.182-59.877-40.808-85.71c-6.987-27.264-4.313-46.645,7.534-54.567,23.459-15.7,74.829,21.335,116.953,84.306s56.734,124.583,33.274,140.278A22.979,22.979,0,0,1,462.57,470.557ZM338.622,247.07a14.98,14.98,0,0,0-8.492,2.3c-8.488,5.675-9.95,22.213-4.013,45.36,6.387,24.921,20.466,54.429,39.635,83.086s41.066,52.932,61.662,68.353c19.134,14.325,34.975,19.284,43.455,13.605,16.78-11.227,6.472-65.518-35.618-128.446C398.938,277.043,359.534,247.07,338.622,247.07Z",
    transform: "translate(-314.039 -238.683)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.456 1.787)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.559,471.644a23.3,23.3,0,0,1-13.8-4.067c-23.013-16.341-6.68-77.526,37.18-139.289h0c43.863-61.759,96.245-97.338,119.262-81s6.68,77.526-37.18,139.289c-20.508,28.873-43.8,53.248-65.583,68.627C357.026,466.084,343.379,471.644,332.559,471.644Zm30.335-138.415c-43.836,61.724-55.656,115.7-39.2,127.392,8.322,5.91,24.294,1.4,43.821-12.386,21.016-14.837,43.586-38.488,63.548-66.6,43.836-61.724,55.656-115.706,39.2-127.4S406.727,271.5,362.894,333.229Z",
    transform: "translate(-308.35 -243.328)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.551)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M322.7,509.728c-75.753,0-135.095-22.112-135.095-50.339S246.952,409.05,322.7,409.05,457.8,431.162,457.8,459.389,398.457,509.728,322.7,509.728Zm0-92.147C247,417.58,196.14,439.2,196.14,459.389S247,501.2,322.7,501.2s126.565-21.616,126.565-41.809S398.415,417.58,322.7,417.58Z",
    transform: "translate(-187.61 -409.05)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 20.954,
    cy: 20.954,
    r: 20.954,
    transform: "translate(301.75 333.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26.499,
    cy: 26.499,
    r: 26.499,
    transform: "translate(215.971 239.144)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26.499,
    cy: 26.499,
    r: 26.499,
    transform: "translate(411.912 347.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26.499,
    cy: 26.499,
    r: 26.499,
    transform: "translate(212.901 408.609)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopAtomo);
export default __webpack_public_path__ + "static/media/top-atomo.143bce51.svg";
export { ForwardRef as ReactComponent };